import styles from './styles.module.less';

interface Props {
	total: number;
	completed: number;
	colors?: {
		completed: string;
		inProgress: string;
		background: string;
	}
}

export function ProgressChip({
	total,
	completed,
	colors: {
		completed: completedColor,
		inProgress: inProgressColor,
		background: backgroundColor,
	} = {
		completed: '#2FB454',
		inProgress: '#0088CC',
		background: '#E8E8E8',
	},
}: Props): JSX.Element {
	const progress = Math.round(completed / total * 100) || 0;
	const fullProgress = progress === 100;
	const progressStyle = {
		width: `${progress > 100 ? 100 : progress}%`,
		backgroundColor: fullProgress ? completedColor : inProgressColor,
	};
	return (
		<div
			className={styles.chip}
			style={{backgroundColor}}
		>
			<div
				className={styles.chipProgress}
				style={progressStyle}
			/>
		</div>
	);
}
